module.exports = __webpack_public_path__ + "static/img/check-icon.73f47da.png";


//////////////////
// WEBPACK FOOTER
// ./app/content/images/check/check-icon.png
// module id = kvLf
// module chunks = 11